<template>
  <DynamicModal
    :showModal="showModalProp"
    :persistent="false"
    @clickOutside="cancel"
    title="Contract Close Out"
    maxWidth="500px"
  >
    <v-container fluid slot="title-buttons" class="py-1">
      <v-row justify="end">
        <v-btn
          icon
          depressed
          color="primary"
          @click="cancel"
        >
          <v-icon color="white">close</v-icon>
        </v-btn>
      </v-row>
    </v-container>
    <v-container fluid slot="content">
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col cols="12" class="px-0">
            <v-card-text>Are you sure you want to close out the selected contract? If so, please enter the end date.</v-card-text>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6" class="pt-0">
            <SimpleDatePicker
              label="End Date"
              :value="endAt"
              :isRequired="true"
              :clearable="true"
              :readonly="false"
              :dense="false"
              @selected-date-change="(newValue) => this.endAt = newValue"
            ></SimpleDatePicker>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
    <v-container fluid slot="buttons" class="pb-0 mb-0">
      <v-row>
        <v-col cols="6">
          <v-btn
            color="primary"
            block
            @click="closeOutAssignment"
          >
            Close Out
          </v-btn>
        </v-col>
        <v-col cols="6">
          <v-btn
            block
            depressed
            outlined
            @click="cancel"
          >
            Back
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </DynamicModal>
</template>
<script>
import { mapActions } from 'vuex'
import DynamicModal from '@/components/dialogs/DynamicModal'
import { SimpleDatePicker } from '@/components/shared/datePickers'
import { mapFields } from '@/vueHelpers/vuex'
import { nextTick } from 'vue'

export default {
  components: {
    DynamicModal,
    SimpleDatePicker
  },
  data () {
    return {
      showModalProp: false
    }
  },
  computed: {
    ...mapFields('assignment', [
      'id',
      'userId',
      'billRate',
      'startAt',
      'endAt',
      'contractTypeId',
      'lengthOfContract',
      'conversionFee',
      'employeeTypeId',
      'corporateName',
      'active',
      'clientId',
      'overtimeEligible',
      'billRateTypeId',
      'payFrequencyId',
      'payRateTypeId',
      'payRate',
      'ein',
      'commissions',
      'expenses',
      'defaultExpensesByClient',
      'vmsFee',
      'workedHoursAverage',
      'jobTitle'
    ])
  },
  methods: {
    ...mapActions('assignment', [
      'getAssignment',
      'saveAssignment',
      'clearAssignment'
    ]),
    async showModal (assignment) {
      this.id = assignment.id
      this.userId = assignment.userId
      this.billRate = assignment.billRate
      this.startAt = assignment.startAt
      this.endAt = assignment.endAt || new Date().toISOString()
      this.contractTypeId = assignment.contractTypeId
      this.lengthOfContract = assignment.lengthOfContract
      this.conversionFee = assignment.conversionFee
      this.employeeTypeId = assignment.employeeTypeId
      this.corporateName = assignment.corporateName
      this.active = assignment.active
      this.clientId = assignment.clientId
      this.overtimeEligible = assignment.overtimeEligible
      this.billRateTypeId = assignment.billRateTypeId
      this.payFrequencyId = assignment.payFrequencyId
      this.payRateTypeId = assignment.payRateTypeId
      this.payRate = assignment.payRate
      this.ein = assignment.ein
      this.commissions = assignment.commissions
      this.expenses = assignment.expenses
      this.defaultExpensesByClient = assignment.defaultExpensesByClient
      this.vmsFee = assignment.vmsFee
      this.workedHoursAverage = assignment.workedHoursAverage
      this.jobTitle = assignment.jobTitle
      this.showModalProp = true
      await nextTick()
      this.$refs.form.resetValidation()
    },
    closeModal () {
      this.showModalProp = false
    },
    cancel () {
      this.closeModal()
      this.$emit('cancel', this.id)
    },
    closeOutAssignment () {
      if (this.$refs.form.validate()) {
        this.saveAssignment().then(() => {
          this.$emit('closedOut')
          this.closeModal()
        })
      }
    }
  }
}
</script>
